import React from 'react';

import { NamedLink } from '../../components';

// Nextmine: samme logo-billede som topbaren, så footer + header matcher præcist.
import logoImage from '../../assets/biketribe-logo-desktop.png';

import css from './SectionNextmineFooter.module.css';

// Nextmine - egen branded footer (overrider Console-hostet footer, som viste
// rå "[Terms]"-links). Rigtige links til Terms, Privacy og kontakt.
const SectionNextmineFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className={css.root}>
      <div className={css.hairline} />
      <div className={css.inner}>
        <div className={css.brandCol}>
          <img className={css.wordmark} src={logoImage} alt="Nextmine" />
          <p className={css.tagline}>Where fine treasures find their next home.</p>
        </div>

        <nav className={css.linksCol} aria-label="Footer">
          <NamedLink name="WantedPage" className={css.link}>
            ISO · Wanted
          </NamedLink>
          <NamedLink name="BlogPage" className={css.link}>
            Journal
          </NamedLink>
          <NamedLink name="TermsOfServicePage" className={css.link}>
            Terms of Service
          </NamedLink>
          <NamedLink name="PrivacyPolicyPage" className={css.link}>
            Privacy Policy
          </NamedLink>
          <NamedLink name="HowPaymentsWorkPage" className={css.link}>
            How payments work
          </NamedLink>
          <NamedLink name="FaqPage" className={css.link}>
            Questions &amp; answers
          </NamedLink>
          <a className={css.link} href="mailto:hi@nextminejewelry.com">
            Contact
          </a>
        </nav>
      </div>

      <div className={css.bottom}>
        <span>© {year} Nextmine · OMJ</span>
      </div>
    </footer>
  );
};

export default SectionNextmineFooter;
